import { useSnackbar } from "notistack";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  MutationFunction,
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "react-query";
import { ApiResponse } from "~/api/GeneratedApi";
import { useApiErrorHandler } from "./useApiErrorHandler";

export function useCustomMutation<
  TData,
  TError,
  TVariables = void,
  TContext = unknown,
>(
  mutationFn: MutationFunction<TData, TVariables>,
  options?: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> {
  const handleApiError = useApiErrorHandler();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const fn = useCallback(
    (context: TVariables) =>
      new Promise<TData>((resolve, reject) => {
        console.log("start creat");
        mutationFn(context)
          .then((res: TData | ApiResponse) => {
            console.log(res);
            if (res !== null && typeof res === "object" && "resultKey" in res) {
              const key = enqueueSnackbar(t(`apiResponses:${res.resultKey}`), {
                key: res.resultKey,
                variant: "success",
                preventDuplicate: true,
                onClick: () => closeSnackbar(key),
              });
            }
            resolve(res as TData);
          })
          .catch((err) => {
            handleApiError(err as Error);
            reject(err);
          });
      }),
    [mutationFn, enqueueSnackbar, t, closeSnackbar, handleApiError],
  );

  return useMutation(fn, options);
}
